import { Box } from '@mui/material'
import React from 'react'
import ProdactsList from '../components/ProdactsList'

function Products() {
  return (
    <Box>
      <ProdactsList />
    </Box>
  )
}

export default Products
